import { GoNumber } from "react-icons/go"
import { IoText } from "react-icons/io5"
import { MdAccessTime } from "react-icons/md"
import { PiTextAlignLeft } from "react-icons/pi"
import { RiListRadio } from "react-icons/ri"
import { RxSwitch } from "react-icons/rx"

export const TagFieldType = {
	TEXT: 1,
	LONGTEXT: 2,
	NUMBER: 3,
	SELECT: 4,
	DATETIME: 5,
	BOOLEAN: 6,
}

export const TagFieldConfig = {
	[TagFieldType.TEXT]: {
		name: 'Texto',
		description: 'Texto curto como um nome ou título',
		color: '#ffcb5c',
		icon: IoText,
	},
	[TagFieldType.LONGTEXT]: {
		name: 'Texto Longo',
		description: 'Texto longo como uma descrição ou mensagem',
		color: '#ff905c',
		icon: PiTextAlignLeft,
	},
	[TagFieldType.NUMBER]: {
		name: 'Número',
		description: 'Número (inteiro ou decimal)',
		color: '#f04848',
		icon: GoNumber,
	},
	[TagFieldType.SELECT]: {
		name: 'Seleção',
		description: 'Selecione valores na lista, singular ou múltiplo',
		color: '#5ca3ff',
		icon: RiListRadio,
	},
	[TagFieldType.DATETIME]: {
		name: 'Data e hora',
		description: 'Um datepicker com horas, minutos e segundos',
		color: '#69db5a',
		icon: MdAccessTime,
	},
	[TagFieldType.BOOLEAN]: {
		name: 'Booleano',
		description: 'Sim ou não, 1 ou 0, verdadeiro ou falso',
		color: '#955cff',
		icon: RxSwitch,
	},
}